import { render } from "./VoucherPurchases.vue?vue&type=template&id=82b70f44&scoped=true"
import script from "./VoucherPurchases.vue?vue&type=script&lang=js"
export * from "./VoucherPurchases.vue?vue&type=script&lang=js"

import "./VoucherPurchases.vue?vue&type=style&index=0&id=82b70f44&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82b70f44"]])

export default __exports__